import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import accordion from './accordion';
import alert from './alert';
import avatar from './avatar';
import badge from './badge';
import booleanInput from './boolean-input';
import breadcrumbs from './breadcrumbs';
import button from './button';
import card from './card';
import drawer from './drawer';
import dropdown from './dropdown';
import input from './input';
import link from './link';
import list from './list';
import modal from './modal';
import overlay from './overlay';
import pagination from './pagination';
import popover from './popover';
import progressBar from './progress-bar';
import rating from './rating';
import select from './select';
import slider from './slider';
import spinner from './spinner';
import table from './table';
import tabs from './tabs';
import tag from './tag';
import toast from './toast';
import { allTokens } from './tokens';
import tooltip from './tooltip';
import type from './type';
export var sparkTheme = _objectSpread(_objectSpread({
  meta: {
    isSpark: true,
    isSparkBase: true
  },
  name: 'Spark',
  config: {
    useCustomProperties: false,
    useRootStyles: false,
    useBodyStyles: false,
    useBorderBox: true
  }
}, allTokens), {}, {
  styles: {
    root: {
      fontFamily: 'base'
    }
  },
  shadows: {
    radioFocus: '0px 0px 0px 2px #4FFFF4'
  },
  spark: {
    element: {
      type: type,
      accordion: accordion,
      alert: alert,
      avatar: avatar,
      badge: badge,
      booleanInput: booleanInput,
      breadcrumbs: breadcrumbs,
      button: button,
      card: card,
      drawer: drawer,
      dropdown: dropdown,
      input: input,
      link: link,
      list: list,
      modal: modal,
      overlay: overlay,
      pagination: pagination,
      popover: popover,
      progressBar: progressBar,
      rating: rating,
      select: select,
      slider: slider,
      spinner: spinner,
      table: table,
      tabs: tabs,
      tag: tag,
      toast: toast,
      tooltip: tooltip
    },
    base: {
      wrapper: {
        boxSizing: 'border-box',
        '& *,& *:before,& *:after': {
          boxSizing: 'inherit'
        }
      }
    }
  }
});